class TextWithIconsSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('[data-text-with-icons-track]');
    if (!this.slider || !this.slider.classList.contains('slider--tablet')) return;

    this.prevButton = this.querySelector('.slider-button--prev');
    this.nextButton = this.querySelector('.slider-button--next');
    this.autoplay = this.slider.dataset.autoplay !== 'false';
    this.speed = Number(this.slider.dataset.speed || 3) * 1000;
    this.timer = null;

    this.onScroll = this.updateButtons.bind(this);
    this.slider.addEventListener('scroll', this.onScroll, { passive: true });

    this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex() - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex() + 1));

    this.updateButtons();
    if (this.autoplay && this.slides().length > 1) this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    this.slider?.removeEventListener('scroll', this.onScroll);
  }

  slides() {
    return Array.from(this.slider.querySelectorAll('.multicolumn-list__item'));
  }

  currentIndex() {
    const slideWidth = this.slider.clientWidth || 1;
    return Math.round(this.slider.scrollLeft / slideWidth);
  }

  goTo(index) {
    const slides = this.slides();
    if (!slides.length) return;

    const normalized = ((index % slides.length) + slides.length) % slides.length;
    this.slider.scrollTo({
      left: slides[normalized].offsetLeft,
      behavior: 'smooth',
    });
    this.stopAutoplay();
    if (this.autoplay) this.startAutoplay();
  }

  updateButtons() {
    const slides = this.slides();
    const index = this.currentIndex();

    if (this.prevButton) this.prevButton.disabled = index <= 0;
    if (this.nextButton) this.nextButton.disabled = index >= slides.length - 1;
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = window.setInterval(() => {
      const slides = this.slides();
      if (slides.length <= 1) return;

      const nextIndex = this.currentIndex() + 1;
      if (nextIndex >= slides.length) {
        this.goTo(0);
      } else {
        this.goTo(nextIndex);
      }
    }, this.speed);
  }

  stopAutoplay() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
}

if (!customElements.get('text-with-icons-slider')) {
  customElements.define('text-with-icons-slider', TextWithIconsSlider);
}
